import React from 'react';

const contact = () => {
  return (
    <div className="row">
      <div className="col s12" style={{ marginTop: 20 }}>
        For any suggestions or feedback please contact{' '}
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://anthonydeguzman.com/"
        >
          Anthony
        </a>{' '}
        at{' '}
        <a href="mailto:email@anthonydeguzman.com">
          email@anthonydeguzman.com
        </a>
      </div>
    </div>
  )
}

export default contact;



// WEBPACK FOOTER //
// ./src/components/Contact.js